import { MediaQueries, mediaQueries } from '../helpers/media-queries'
import { breakPointsPx } from './breakpoints'
import { colors, statusColors, ThemeColorsProps, ThemeStatusColorsProps } from './colors'
import { FontsProps, fontsSettings } from './fonts-settings'
import { Space, space } from './space'

export interface Theme {
  colors: ThemeColorsProps & ThemeStatusColorsProps
  space: { [key in Space]: string }
  fonts: FontsProps
  boxShadow: string
  tabsButtonPadding: string
  gutter: number
  defaultRowsPerPage: number
  defaultRowsPerPageForClient: number
  drawerWidthClosed: number
  drawerWidthOpen: number
  appSwitcherWidth: number
  breakpoints: Array<string>
  mediaQueries: { [key in MediaQueries]: string }
}

export const theme: Theme = {
  colors: {
    ...colors,
    ...statusColors,
  },
  space: {
    ...space,
  },
  fonts: {
    ...fontsSettings,
  },
  boxShadow: '0px 3px 30px rgba(77, 90, 106, 0.25), 0px 0px 30px rgba(77, 90, 106, 0.25), 0px 4px 30px rgba(0, 0, 0, 0.1)',
  tabsButtonPadding: '12px',
  gutter: 4,
  defaultRowsPerPage: 50,
  defaultRowsPerPageForClient: 10,
  drawerWidthClosed: 64,
  drawerWidthOpen: 260,
  appSwitcherWidth: 206,
  breakpoints: [breakPointsPx.md, breakPointsPx.lg, breakPointsPx.xl],
  mediaQueries: {
    ...mediaQueries,
  },
}
